import { render } from "./experience-cell-date.vue?vue&type=template&id=ed8e504c&scoped=true"
import script from "./experience-cell-date.vue?vue&type=script&lang=js"
export * from "./experience-cell-date.vue?vue&type=script&lang=js"

import "./experience-cell-date.vue?vue&type=style&index=0&id=ed8e504c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed8e504c"]])

export default __exports__